module.exports = __webpack_public_path__ + "img/white.35b6151.svg";